import type { FC } from "react"
import type { SvgIcons } from "../../type/Icons"

export const  Heart: FC<SvgIcons>=({fill="",width="32",height='32'})=>{
    return (
        <>
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" className="size-6 mt-0.5"><path fill={fill ??"#B3BEC1"} d="M25.887 17.426 16 28.054 6.095 17.408l-.018-.018-.453-.488.02-.023c-2.406-3.098-2.255-7.715.45-10.623 2.707-2.91 7.002-3.07 9.886-.484l.02-.024.023.024.045-.042c2.883-2.543 7.146-2.368 9.837.526 2.706 2.908 2.857 7.525.45 10.624l.021.022-.455.49z"></path></svg>
        </>

    )
}